import _get from 'lodash/get';
import deepmerge from 'deepmerge';
import { translate } from '@atc/bonnet-parameters';
import getConfig from '@bonnet/core/config';
import querystring from 'querystring';
import { getRandomId } from '@atc/page-instance-id';
let environmentName = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'dev';
function getClientAddress(req, site) {
  let ip = 'nl';
  if (_get(req, 'headers.x-forwarded-for') != null || _get(req, 'connection.remoteAddress') != null) {
    ip = (req.headers['x-forwarded-for'] || '').split(',')[0] || req.connection.remoteAddress;
  } else {
    ip = _get(site, 'ip');
  }
  return ip;
}
function getBrowserPrefetch(req, birf) {
  let browserPrefetch;
  if (_get(req, ['headers']) != null) {
    const xpurpose = _get(req, ['headers', 'x-purpose'], '');
    const xmoz = _get(req, ['headers', 'x-moz'], '');
    const prefetch = xpurpose + xmoz;
    browserPrefetch = prefetch.length > 0;
  } else {
    browserPrefetch = _get(birf, 'browserPrefetch');
  }
  return browserPrefetch;
}
function getDeviceValue(req, site) {
  let deviceType = 'desktop';
  if (_get(req, 'device.type') != null) {
    const deviceRaw = req.device.type;
    if (deviceRaw === 'phone') {
      deviceType = 'mobile';
    } else {
      deviceType = deviceRaw;
    }
  } else {
    deviceType = _get(site, 'deviceType');
  }
  return deviceType;
}
function getMyAutotraderId(cookie) {
  let id = '';
  cookie.split('&').forEach(function () {
    let userInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    const values = userInfo.split('=') || [];
    if (values.length > 1) {
      const [key, value] = values;
      if (key === 'pub') {
        id = value;
      }
    }
  });
  return id;
}
const getMakeCodes = query => {
  let makeCodeList = [];
  if (query.makeCode) {
    makeCodeList = [].concat(query.makeCode);
  }
  if (makeCodeList.length > 0) {
    return makeCodeList;
  }
  return ['any'];
};
const getModelCodes = query => {
  let makeCodeList = [];
  let modelCodeList = [];
  if (query.makeCode && query.modelCode) {
    makeCodeList = [].concat(query.makeCode);
    modelCodeList = [].concat(query.modelCode);
  }
  if (modelCodeList.length > 0 && makeCodeList.length > 0) {
    return modelCodeList;
  }
  return ['any'];
};
const getBodyCodes = query => {
  let bodyCodeList = [];
  if (query.vehicleStyleCode) {
    bodyCodeList = [].concat(query.vehicleStyleCode);
  }
  return bodyCodeList;
};
const getSearchTypes = (query, brand) => {
  let searchTypes = [];
  if (query.listingType) {
    searchTypes = [].concat(query.listingType);
  }
  if (searchTypes.length > 0) {
    if (brand === 'kbb' || searchTypes.length <= 1) {
      return searchTypes;
    }
    return ['both'];
  }
  return ['all'];
};
export default function addDataisland() {
  let {
    data = {},
    dataKey = 'dataIsland'
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return ctx => {
    // Overwriting array merges so makecode/modelcode lists dont contain duplicate or incorrect values
    const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray;
    const query = translate(ctx.query, {
      target: 'lsc'
    });
    const brand = _get(ctx, 'data.brand');
    const state = ctx.store.getState();
    const site = _get(state, 'birf.pageData.page.site', {});
    const demographic = _get(state, 'birf.pageData.page.demographic', {});
    const birf = _get(state, 'birf.pageData.page.BIRF', {});

    // cookies
    const cookieInfo = ctx.cookies.get('ATC_ID');
    const exp = ctx.cookies.get('exp');
    const myAutotrader = ctx.cookies.get('MYAUTOTRADER') || '';
    const parsedMyAtcCookie = querystring.parse(myAutotrader) || {};
    let myLt = 0;
    if (parsedMyAtcCookie.soc === '1') {
      myLt = 2;
    } else if (parsedMyAtcCookie.soc === '0') {
      myLt = 1;
    }
    const myId = getMyAutotraderId(myAutotrader);

    // lang
    const language = _get(ctx.req, ['headers', 'accept-language']);
    const makeCode = getMakeCodes(query);
    const modelCode = getModelCodes(query);
    const {
      publicRuntimeConfig
    } = getConfig();
    if (!_get(ctx, 'req', false)) {
      environmentName = _get(publicRuntimeConfig, 'environment', 'dev');
    }
    const dataIsland = {
      page: {
        site: {
          environment: environmentName,
          site: brand === 'kbb' ? 'www.kbb.com' : 'autotrader.com',
          siteVersion: process.env.npm_package_version,
          atcCookie: cookieInfo,
          myAtcId: myAutotrader ? '1' : '0',
          myAtc: myAutotrader,
          requestedPage: _get(ctx.req, 'localAddress', site.requestedPage),
          referringPage: _get(ctx.req, 'headers.referer', site.referringPage),
          search_lang: language != null ? language.split(',')[0] : site.search_lang,
          deviceType: getDeviceValue(ctx.req, site),
          sessionId: _get(ctx.req, 'sessionId', site.sessionId),
          ip: getClientAddress(ctx.req, site),
          camg_reqid: _get(ctx.req, 'headers.CAMG_REQID', site.camg_reqid),
          camg_tranid: _get(ctx.req, 'headers.CAMG_RTRANID', site.camg_tranid)
        },
        location: {
          address: query.zip,
          ipZipCode: '',
          dma: _get(query, 'dma.code'),
          distance: query.searchRadius
        },
        vehicle: {
          body_code: getBodyCodes(query),
          car_year: query.year,
          fuel: query.fuelTypeGroup,
          make: makeCode,
          model: modelCode,
          series: query.seriesCode,
          trim: query.trimCode,
          search_max_price: query.maxPrice,
          search_max_year: query.endYear,
          search_min_price: query.minPrice,
          search_min_year: query.startYear,
          search_type: getSearchTypes(query, brand),
          Car_Type: query.listingType,
          search_distance: query.searchRadius,
          color: query.extColorSimple,
          car_ids: ctx.data.listings && ctx.data.listings.map(listing => listing.id)
        },
        owner: {
          dealer_id: query.ownerId
        },
        demographic: {
          hispanic: language != null ? language.includes('es') : demographic.hispanic
        },
        BIRF: {
          test_name: exp,
          test_nme: exp,
          browserPrefetch: getBrowserPrefetch(ctx.req, birf),
          logDomain: 'https://www.autotrader.com',
          pg_inst: getRandomId(),
          rd_page: '',
          lnx: query.lnx || query.LNX,
          cid: query.cid || query.CID,
          my: myAutotrader ? 1 : 0,
          ref_url: _get(ctx.req, 'headers.referer', birf.ref_url),
          my_lt: myLt,
          my_id: myId,
          Log: '1',
          first_rec_num: query.firstRecord,
          num_records: query.numRecords,
          make: makeCode,
          model: modelCode,
          drive: query.driveGroup,
          distance: query.searchRadius,
          c: query.ownerId,
          z: query.zip,
          srch_type: getSearchTypes(query, brand)
        },
        doubleclick: {},
        comscore: {
          c1: '2',
          c2: '6035944',
          c3: '',
          c4: '',
          c5: '',
          c6: '',
          c15: ''
        }
      }
    };
    ctx.data[dataKey] = deepmerge(dataIsland, data, {
      arrayMerge: overwriteMerge
    });
  };
}